import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';

import { PasswordStrength } from './password-strength.validator';

@Directive({
    selector: '[passwordStrength]',
    standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordStrengthDirective, multi: true }]
})
export class PasswordStrengthDirective implements Validator {
  @Input('passwordStrength') passwordStrength: string[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
      return PasswordStrength(this.passwordStrength[0] )(formGroup);
    }
}
